import { render, staticRenderFns } from "./TextareaEditor.vue?vue&type=template&id=c3856c9e&scoped=true&"
import script from "./TextareaEditor.vue?vue&type=script&lang=js&"
export * from "./TextareaEditor.vue?vue&type=script&lang=js&"
import style0 from "./TextareaEditor.vue?vue&type=style&index=0&id=c3856c9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3856c9e",
  null
  
)

export default component.exports